module.exports = __webpack_public_path__ + "imgs/leaf411-logo.930ca4c1f6a55094905ec98d17b75239.svg";